import { Component, OnInit, ViewChildren, EventEmitter, Output, ElementRef, AfterViewInit, ViewChild, Input, SimpleChanges, OnChanges, Optional } from '@angular/core';
import { FormGroup, UntypedFormBuilder, Validators, UntypedFormArray, UntypedFormControl } from '@angular/forms';
import { REG_EX } from '@app/_helpers';

@Component({
    selector: 'app-otp-input',
    templateUrl: './otp-input.component.html',
    styleUrls: ['./otp-input.component.scss']
})
export class OtpInputComponent implements OnInit, AfterViewInit {
    otpForm: UntypedFormArray;
    @Optional() @Input('applyInitialFocus') applyInitialFocus: boolean = false;
    @ViewChildren('formRow') rows: any;
    @Output() checkOtp = new EventEmitter();
    NumbersOnly = REG_EX.digitsOnly;

    constructor(
        private fb: UntypedFormBuilder
    ) {
        this.otpForm = new UntypedFormArray([
            new UntypedFormControl('', [Validators.required]),
            new UntypedFormControl('', [Validators.required]),
            new UntypedFormControl('', [Validators.required]),
            new UntypedFormControl('', [Validators.required]),
            new UntypedFormControl('', [Validators.required]),
            new UntypedFormControl('', [Validators.required]),
        ]);
    }

    ngOnInit(): void {
        this.otpForm.valueChanges.subscribe((value) => {
            if (value && this.otpForm.valid) {
                this.checkOtp.emit();
            }
        });
    }

    ngAfterViewInit(): void {
        this.applyInitialFocus && this.applyFocus();
    }

    applyFocus() {
        setTimeout(() => {
            this.rows._results[0].nativeElement.focus();
        }, 200);

    }

    keyUpEvent(event, index) {
        // This logic updates the focus on other input as soon as one input is filled,
        // like in an typical otp field.
        // 16 is for shift . If user has enter shift doing nothing
        let pos = index;
        if ((event.keyCode === 8 && event.which === 8) || (event.shiftKey && event.keyCode === 9)) {
            pos = index - 1;
        } else if (event.keyCode !== 16) {
            pos = index + 1;
        }
        if (pos > -1 && pos < 6) {
            this.rows._results[pos].nativeElement.focus();
        }
    }

    getOtp() {
        return this.otpForm.controls.map(control => control.value).join('');
    }

}
